export type BenefitsListUrlState = {
  name: string;
  supplierid: string | null;
  country: string | null;
  city: string | null;
  type: string | null;
  activityType: string | null;
  page: number;
  sortField: string;
  sortOrder: 'asc' | 'desc';
};

export const buildBenefitsListSearch = (
  params: BenefitsListUrlState | null | undefined,
) => {
  if (!params) return '';
  const search = new URLSearchParams();
  if (params.name != null && params.name !== '') {
    search.set('name', params.name);
  }
  if (params.supplierid != null && params.supplierid !== '') {
    search.set('supplierid', params.supplierid);
  }
  if (params.country != null && params.country !== '') {
    search.set('country', params.country);
  }
  if (params.city != null && params.city !== '') {
    search.set('city', params.city);
  }
  if (params.type != null && params.type !== '') {
    search.set('type', params.type);
  }
  if (params.activityType != null && params.activityType !== '') {
    search.set('activityType', params.activityType);
  }
  if (params.page != null && params.page > 1) {
    search.set('page', String(params.page));
  }
  if (params.sortField != null && params.sortField !== '') {
    search.set('sortField', params.sortField);
    search.set('sortOrder', params.sortOrder);
  }
  const str = search.toString();
  return str ? `?${str}` : '';
};
